import {useDispatch, useSelector} from "react-redux";
import {Navigate} from "react-router-dom";
import ConfirmationDialog from "../components/ConfirmationDialog";
import React, {useEffect, useState} from "react";
import {logOut} from "../redux/slices/authSlice";
import {timeInSeconds} from "../helpers/timeInSeconds";

const AuthGuard = ({children}) => {
    const {isLoggedIn} = useSelector((state) => state?.auth);
    const dispatch = useDispatch();
    const [openSessionDialog, setOpenSessionDialog] = useState(false);
    const [counterMsg, setCounterMsg] = useState(null);
    const END_SESSION_TIMEOUT_IN_SECONDS = 3 * 60;
    const WARNING_TIME_IN_SECONDS = 2 * 60;

    useEffect(() => {
        const intervalId = setInterval(() => {
            const storedSessionTimeout = parseInt(localStorage.getItem("sessionTimeout"), 10);
            const passedSeconds = timeInSeconds() - storedSessionTimeout;
            const remainingSeconds = END_SESSION_TIMEOUT_IN_SECONDS - passedSeconds;

            console.log('Remaining Time: ', remainingSeconds)

            // Checking for handling Logout after  passing the waiting time
            if (remainingSeconds <= 0)
                handleLogout()

            // Checking for updating the countdown timer of the dialog message
            if (remainingSeconds <= 60)
                setCounterMsg(remainingSeconds)

            // Checking for appearing the warning dialog
            if (passedSeconds >= WARNING_TIME_IN_SECONDS && !openSessionDialog)
                setOpenSessionDialog(true);
        }, 1000)
        return () => clearInterval(intervalId)
    }, [])

    useEffect(() => {
        // stay active in all multi tabs open
        const handleStorage = (event) => {
            if (event.key === "logoutFromAllTabs") {
                localStorage.removeItem("sessionTimeout");
                localStorage.removeItem("logoutFromAllTabs"); // trigger event for multi tabs open
                dispatch(logOut());
            }
        };

        window.addEventListener("storage", handleStorage);
    }, []);

    const handleStayActive = () => {
        localStorage.setItem("sessionTimeout", timeInSeconds());
    }

    const handleLogout = () => {
        localStorage.setItem("logoutFromAllTabs", timeInSeconds()); // trigger event for multi tabs open
        dispatch(logOut());
    }

    return isLoggedIn ? <>
        <ConfirmationDialog
            title="Action Required"
            description={`You will be logged out in ${counterMsg} seconds.`}
            btnConfirmName={'Stay'}
            hasCancel={false}
            hasClose={false}
            open={openSessionDialog}
            onClose={(value, reason) => {
                if (reason === "backdropClick")
                    return;

                if (value) {
                    handleStayActive()
                } else {
                    handleLogout()
                }
                setOpenSessionDialog(false);
            }}
        />
        {children}
    </> : <Navigate to="/"/>;
};

export default AuthGuard;
